var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKaleidescape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.359,
    height: 25.25,
    viewBox: "0 0 22.359 25.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #7d7d7d;\n      }\n\n      .cls-2 {\n        fill: rgba(0,0,0,0);\n        stroke: #7d7d7d;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-miterlimit: 10;\n        stroke-width: 0.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11292",
    "data-name": "Group 11292",
    transform: "translate(-1043.75 -3966)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4687",
    "data-name": "Path 4687",
    className: "cls-1",
    d: "M277.495,161.755l-1.995,1.19V158l2.088,1.251,2.088,1.221Z",
    transform: "translate(774.311 3811.339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4688",
    "data-name": "Path 4688",
    className: "cls-1",
    d: "M277.495,477.755l-1.995,1.19V474l2.088,1.251,2.088,1.221Z",
    transform: "translate(774.311 3502.017)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4689",
    "data-name": "Path 4689",
    className: "cls-2",
    d: "M2.495,320.755.5,321.945V317l2.088,1.251,2.088,1.221Z",
    transform: "translate(1043.5 3655.699)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4690",
    "data-name": "Path 4690",
    className: "cls-1",
    d: "M2.495,636.755.5,637.945V633l2.088,1.251,2.088,1.221Z",
    transform: "translate(1043.5 3346.377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4691",
    "data-name": "Path 4691",
    className: "cls-1",
    d: "M825.495,162.755l-1.995,1.19V159l2.088,1.251,2.088,1.221Z",
    transform: "translate(237.892 3810.36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4692",
    "data-name": "Path 4692",
    className: "cls-1",
    d: "M825.495,794.755l-1.995,1.19V791l2.088,1.251,2.088,1.221Z",
    transform: "translate(237.892 3191.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4693",
    "data-name": "Path 4693",
    className: "cls-2",
    d: "M551.495,319.755l-1.995,1.19V316l2.088,1.251,2.088,1.221Z",
    transform: "translate(506.102 3656.678)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4694",
    "data-name": "Path 4694",
    className: "cls-2",
    d: "M551.495,635.755l-1.995,1.19V632l2.088,1.251,2.088,1.222Z",
    transform: "translate(506.102 3347.356)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4695",
    "data-name": "Path 4695",
    className: "cls-2",
    d: "M551.495,952.755l-1.995,1.19V949l2.088,1.251,2.088,1.221Z",
    transform: "translate(506.102 3037.055)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4696",
    "data-name": "Path 4696",
    className: "cls-1",
    d: "M551.495,3.755,549.5,4.945V0l2.088,1.251,2.088,1.221Z",
    transform: "translate(506.102 3966)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4697",
    "data-name": "Path 4697",
    className: "cls-1",
    d: "M28.283,161.755l1.993,1.19V158l-2.088,1.251L26.1,160.473Z",
    transform: "translate(1018.441 3811.339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4698",
    "data-name": "Path 4698",
    className: "cls-1",
    d: "M28.283,477.755l1.993,1.19V474l-2.088,1.251L26.1,476.473Z",
    transform: "translate(1018.441 3502.017)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4699",
    "data-name": "Path 4699",
    className: "cls-2",
    d: "M28.283,794.755l1.993,1.19V791l-2.088,1.251L26.1,793.473Z",
    transform: "translate(1018.441 3191.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4700",
    "data-name": "Path 4700",
    className: "cls-2",
    d: "M304.283,636.755l1.993,1.19V633l-2.088,1.251-2.088,1.221Z",
    transform: "translate(748.274 3346.377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4701",
    "data-name": "Path 4701",
    className: "cls-2",
    d: "M304.283,952.755l1.993,1.19V949l-2.088,1.251-2.088,1.221Z",
    transform: "translate(748.274 3037.055)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4702",
    "data-name": "Path 4702",
    className: "cls-1",
    d: "M304.283,320.755l1.993,1.19V317l-2.088,1.251-2.088,1.221Z",
    transform: "translate(748.274 3655.699)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4703",
    "data-name": "Path 4703",
    className: "cls-2",
    d: "M579.283,162.755l1.993,1.19V159l-2.088,1.251-2.088,1.221Z",
    transform: "translate(479.085 3810.36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4704",
    "data-name": "Path 4704",
    className: "cls-1",
    d: "M579.283,794.755l1.993,1.19V791l-2.088,1.251-2.088,1.221Z",
    transform: "translate(479.085 3191.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4705",
    "data-name": "Path 4705",
    className: "cls-1",
    d: "M851.283,320.755l1.993,1.19V317l-2.088,1.251-2.088,1.221Z",
    transform: "translate(212.833 3655.699)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4706",
    "data-name": "Path 4706",
    className: "cls-1",
    d: "M851.283,635.755l1.993,1.19V632l-2.088,1.251-2.088,1.222Z",
    transform: "translate(212.833 3347.356)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaleidescape);
export default __webpack_public_path__ + "static/media/kaleidescape.fd773a1730b1514d1b3d7b18dc5fa44b.svg";
export { ForwardRef as ReactComponent };